import { IUser } from "./../../../commons/interfaces";
import { useMemo, useState } from "react";
import { ICodename, IResource, IRole } from "../../../commons/interfaces";
import { AccessMode, ResourceType, RoleType } from "../../../constants/enums";
import ResourceService from "../../../services/identity/resourceService";
import ServiceService from "../../../services/identity/service.service";
import RoleService from "../../../services/identity/role.serice";
import { useCommonComponentContext } from "../../../providers/CommonComponentProvider";
import GroupService from "../../../services/identity/group.service";
import Helpers from "../../../commons/helpers";
import { RoleHelpers } from "../../../commons/roleHelpers";
import UserService from "../../../services/identity/user.service";

export const useSelectData = () => {
    const { clientId, tenantCode, serviceCode, userInfo, language } = useCommonComponentContext();
    const [resources, setResources] = useState<IResource[]>([]);
    const [services, setServices] = useState<ICodename[]>([]);
    const [roles, setRoles] = useState<ICodename[]>([]);
    const [groups, setGroups] = useState<ICodename[]>([]);
    const [users, setUsers] = useState<ICodename[]>([]);

    const roleTypeList = useMemo<ICodename[]>(
        () => [
            { code: RoleType.Owner, name: "Owner" },
            { code: RoleType.Admin, name: "Admin" },
            { code: RoleType.GroupAdmin, name: "Group Admin" },
            { code: RoleType.Member, name: "Member" },
            { code: RoleType.Custom, name: "Custom" },
        ],
        []
    );

    const roleGroup = [
        {
            code: RoleType.Service,
            name: "Service",
        },
        {
            code: RoleType.TenantOrMembership,
            name: "Tenant",
        },
        {
            code: RoleType.Normal,
            name: "Normal",
        },
    ];

    const getAllRole = async (serviceCode: string) => {
        try {
            let listTemp: ICodename[] = [];
            const result = await RoleService.getAll({
                status: 1,
                serviceCode,
                clientId,
                organizationId: userInfo?.userProfile?.organizationId || undefined,
            });
            result.forEach((e) => {
                listTemp.push({
                    code: e.roleCode,
                    name: e.roleName,
                });
            });
            setRoles(listTemp);
        } catch (error) {}
    };

    const getAllService = async (searchText?: string) => {
        try {
            let listTemp: ICodename[] = [];
            const result = await ServiceService.getAll({ searchText: searchText });
            result.forEach((e) => {
                listTemp.push({
                    code: e.serviceCode,
                    name: e.serviceName,
                });
            });
            setServices(listTemp);
        } catch (error) {}
    };

    const getAllResource = async (serviceCode: string) => {
        try {
            const result = await ResourceService.getAll({
                serviceCode: serviceCode,
                resourceType: [ResourceType.Module],
                accessMode: AccessMode.PrivateRBAC,
            });
            setResources(result);
        } catch (error) {}
    };

    const getAllGroup = async (serviceCode: string) => {
        try {
            let listTemp: ICodename[] = [];
            const result = await GroupService.getAll({
                clientId,
                serviceCode,
                organizationId: userInfo?.userProfile?.organizationId || "0",
            });
            result.forEach((e: any) => {
                listTemp.push({
                    code: e.id,
                    name: Helpers.getDefaultValueMultiLanguage(e.name, language),
                });
            });
            setGroups(listTemp);
        } catch (error) {}
    };

    const getUsers = async (ids: string[]) => {
        try {
            if (RoleHelpers.isSuperAdmin(userInfo?.userProfile?.roleType, serviceCode)) {
                const result = await UserService.getServiceUserPaged({
                    pageNumber: 1,
                    pageSize: ids.length,
                    listStatus: [1],
                    serviceCode: serviceCode,
                    selectedIds: ids,
                });
                // setUsers(result.selectedItems || []);
                setUsers(
                    result.items.map((el) => ({
                        code: el.id,
                        name: Helpers.getFullName(el),
                        detail: {
                            avatarUrl: el.avatarUrl,
                        },
                    }))
                );
            }
            if (!RoleHelpers.isSuperAdmin(userInfo?.userProfile?.roleType, serviceCode)) {
                const result = await UserService.getPaged({
                    pageNumber: 1,
                    pageSize: ids.length,
                    listStatus: [1],
                    serviceCode: serviceCode,
                    selectedIds: ids,
                });
                // setUsers(result.selectedItems || []);
                setUsers(
                    result.items.map((el) => ({
                        code: el.id,
                        name: Helpers.getFullName(el),
                        detail: {
                            avatarUrl: el.avatarUrl,
                        },
                    }))
                );
            }
        } catch (error) {}
    };

    return {
        resources,
        services,
        roleGroup,
        roleTypeList,
        roles,
        groups,
        users,
        getAllResource,
        getAllService,
        getAllGroup,
        getAllRole,
        getUsers,
    };
};

export default useSelectData;
